/**
 * functionFilter.js
 *
 * Defines available user function/role options for use in filter dropdowns.
 * Used to filter data by the user's professional function or role.
 */

export default [
  'Administrative/Middle Management',
  'Business Professional',
  'Executive Management',
  'Faculty/Educator/Training Professional',
  'Information Security',
  'IT Operations',
  'IT Specialist',
  'Software Development',
  'Student',
  'Others',
];
